export const notificationTypes = {
    REMINDER: 'reminder',
    CHAT: 'chat',
    APPOINTMENT: 'appointment',
    NEWS: 'news',
    FRIENDSHIP: 'friendship'
};
